import { reactLocalStorage } from 'reactjs-localstorage';
import FilterDate from '../components/filter/FilterDate';
import FilterMultiSelect from '../components/filter/FilterMultiSelect';

import Const from '../util/Constants';
import Display from '../util/Display';

class ViewController {

  static MainView = 0;
  static Public = 1;
  static Role = 2;
  static User = 3;

  static getViews = model => {
    let views = reactLocalStorage.getObject(Const.Views);
    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const name = `All ${Display.ModulLabelValue(model)}`;
    views = [ ...views.filter(view => {
        if(view.model !== model) {
          return false; 
        }
        if(view.type === ViewController.MainView) {
          return (!view.role && !view.users)
            || (view.roles && view.roles.includes(Const.Opt + user.role + Const.Opt))
            || (view.users && view.users.includes(Const.Opt + user.user_id + Const.Opt));
        } 
        if(view.type === ViewController.Public) {
          return true;
        }
        if(view.type === ViewController.Role) {
          return view.roles && view.roles.includes(Const.Opt + user.role + Const.Opt);
        } 
        if(view.type === ViewController.User) {
          return view.users && view.users.includes(Const.Opt + user.user_id + Const.Opt);
        }
        return false;
      })
    ];
    
    const view = views.find(view => view.type === 0);
    if(!view) {
      return [ { id: 0, name, type: 0, view_order: -100 }, ...views ].sort((l, r) => l.view_order - r.view_order);
    } else {
      return views.sort((l, r) => l.view_order - r.view_order);
    }
  }

  static getRestrictionsView = model => {
    const views = reactLocalStorage.getObject(Const.Views);
    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const view = views.filter(view => {

      if(view.model !== model) { 
        return false; 
      }
      if(view.type === ViewController.MainView) {
        return (view.roles && view.roles.includes(Const.Opt + user.role + Const.Opt))
        || (view.users && view.users.includes(Const.Opt + user.user_id + Const.Opt));
      } 
      if(view.type === ViewController.Role) {
        return view.roles && view.roles.includes(Const.Opt + user.role + Const.Opt);
      } 
      if(view.type === ViewController.User) {
        return view.users && view.users.includes(Const.Opt + user.user_id + Const.Opt);
      }
      return false; 
    }).find(view => view.type === 0);
    return view ? view.filters ? view.filters : [] : [];
  }

  static filters = (filters, fixFiltes, mainFilters, restricted, field) => {
    const key = field ? field : 'responsible_person';
    if(restricted) {
      const user = reactLocalStorage.getObject(Const.LoggedInUser);
      const users = user.child;
      users.push(user.user_id);
      const restrict = filters.find(filter => filter.field === key);
      if(!restrict) {
        filters.push({field: key, type: 'multiselect~user',
          condition: 'in', value: `${Const.Opt}${users.join(Const.Opt)}${Const.Opt}`});
      } else {
        let values = restrict.value.substring(0, restrict.value.length - 1).split(Const.Opt);
        values = values.filter(value => users.find(user => user === parseInt(value)));
        restrict.value = `${Const.Opt}${values.join(Const.Opt)}${Const.Opt}`;
      }
    }

    if(mainFilters) {
      for(let i = 0; i < mainFilters.length; i++) {
        const filter = filters.find(filter => filter.field === mainFilters[i].field);
        let value = mainFilters[i].value ? mainFilters[i].value : mainFilters[i].condition;
        value = FilterDate.getValue(value, mainFilters[i].condition);
        value = FilterMultiSelect.getDefaultValue(value);
        if(mainFilters[i]?.type?.includes(Const.Select)) {
          if(filter) {
            const FilterValue = Const.SelectValues(filter.value);
            const Values = Const.SelectValues(value);
            const tmp = FilterValue.filter(item => Values.find(innerItem => innerItem === item));
            if(tmp.length > 0) {
              filter.value = `${Const.Opt}${tmp.join(Const.Opt)}${Const.Opt}`;
            } else {
              filter.value = value;
              filter.condition = 'in';
            }
          } else {
            filters.push({ ...mainFilters[i], condition: 'in', value });
          }
        } else {
          if(filter) {
            filter.value = value;
          }
          else {
            filters.push({ ...mainFilters[i], value });
          }
        }
      }
    }
    if(fixFiltes) {
      for(let i = 0; i < fixFiltes.length; i++) {
        const filter = filters.find(filter => filter.field === fixFiltes[i].field);
        let value = fixFiltes[i].value ? fixFiltes[i].value : fixFiltes[i].condition;
        value = FilterDate.getValue(value, fixFiltes[i].condition);
        value = FilterMultiSelect.getDefaultValue(value);
        if(fixFiltes[i]?.type?.includes(Const.Select)) {
          if(filter) {
            const FilterValue = Const.SelectValues(filter.value);
            const Values = Const.SelectValues(value);
            const tmp = FilterValue.filter(item => Values.find(innerItem => innerItem === item));
            if(tmp.length > 0) {
              filter.value = `${Const.Opt}${tmp.join(Const.Opt)}${Const.Opt}`;
              filter.condition = 'in';
            } else {
              filter.value = value;
              filter.condition = 'in';
            }
          } else {
            filters.push({ ...fixFiltes[i], condition: 'in', value });
          }
        } else {
          if(filter) { 
            filter.value = value; 
          } else {
            filters.push({ ...fixFiltes[i], value });
          }
        }
      }
    }
    return filters;
  }

  static ViewRestriction = (Restricted, model) => {
    if(Restricted) {
      const user = reactLocalStorage.getObject(Const.LoggedInUser);
      const users = user.child;
      users.push(user.user_id);

      if(typeof model['responsible_person'] === 'string' && model['responsible_person'].length > 2) {
        let assignUsers = model['responsible_person'];
        assignUsers = assignUsers.substring(1, assignUsers.length - 1).split(Const.Opt).map(user => parseInt(user));
        for(let i = 0; i < assignUsers.length; i++) {
          if(users.find(user => user === assignUsers[i])) {
            return true;
          }
        }
      } else {
        return users.find(user => user === model['responsible_person']);
      }
      return false;
    }
    return true;
  }
}
export default ViewController;